import Smartlook from 'smartlook-client';

const sendEventToSmartLook = (eventName, dataProperties) => {
  Smartlook.track(eventName, dataProperties);
};

export const sendSmPageViewEvent = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmSelectItemEvent = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmViewItemListEvent = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmViewItemEvent = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmClickaShareEvent = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmFilterClickEvent = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmInfoPopupViewedEvent = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmViewAllLinkEvent = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmAddToCartEvent = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmCheckoutEvent = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmPackageBookingEvent = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmPackageBookingErrorEvent = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmPackagePaymentCancelledEvent = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmCancelPackagesEvent = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};

export const sendSmRebookPackagesEvent = (eventName, data) => {
  sendEventToSmartLook(eventName, data);
};